import styled from "@emotion/styled";
import { HEADING, TERTIARY_GREY } from "src/constants/colors";

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 48px 0px 34px 0px;
`;

export const HeaderTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const HeaderTitle = styled.div`
  color: ${HEADING};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 28px;
  font-weight: 600;
  text-transform: capitalize;
`;

export const HeaderSubTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${TERTIARY_GREY};
  font-size: 14px
  font-weight: 400;
  text-align: left;
  line-height: 20px;
`;
